/** Internal dependencies */
import whenDocumentReady from '../../../../../assets/src/scripts/utilities/whenDocumentReady';
import { checkout } from './components/checkout';
import { coupons } from './components/coupons';
import { loginForm } from './components/loginForm';
import { termsToggle } from './components/termsToggle';

whenDocumentReady(initWidget);

function initWidget() {
    checkout.init();
    coupons.init();
    loginForm.init();
    termsToggle.init();
}
